import React from 'react'
import PropTypes from 'prop-types'

const styleSummaryTable = {
  color: '#000',
}
const styleSummaryTableRow = {
  lineHeight: '2rem',
}

const SummaryTable = ({ summary }) => (
  <table style={styleSummaryTable}>
    <tbody>
      {summary.map(
        data =>
          data.value > 0 && (
            <tr key={data.key} style={styleSummaryTableRow}>
              <td width="80%">
                <strong>{data.label}</strong>
              </td>
              <td width="20%" align="right">
                {data.value}
              </td>
            </tr>
          )
      )}
    </tbody>
  </table>
)

SummaryTable.propTypes = {
  summary: PropTypes.array,
}

export default SummaryTable
